export { RightClickTriggerModule } from './rightclicktrigger.module';
export { RightClickTriggerDirective } from './rightclicktrigger.directive';